var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_70_1",
    "data-name": "Component 70 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_503",
    "data-name": "Rectangle 503",
    width: 44,
    height: 44,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "edit_FILL0_wght400_GRAD0_opsz40",
    d: "M7.289,27.211H8.928l14-14L21.291,11.57l-14,14ZM27.78,11.57,22.93,6.754l1.571-1.6a2.308,2.308,0,0,1,3.21,0l1.639,1.639a2.219,2.219,0,0,1,.666,1.588,2.1,2.1,0,0,1-.632,1.589Zm-1.639,1.639L9.85,29.5H5V24.65L21.291,8.359Zm-4.03-.82-.82-.82,1.639,1.639Z",
    transform: "translate(5.126 5.188)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilEdit);
export default __webpack_public_path__ + "static/media/pencilEdit.07163004ae0beec4c1613666a2313bda.svg";
export { ForwardRef as ReactComponent };